import { render, staticRenderFns } from "./BaseStep.vue?vue&type=template&id=6cf7a721&"
import script from "./BaseStep.vue?vue&type=script&lang=ts&"
export * from "./BaseStep.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports